// eslint-disable-next-line import/prefer-default-export
export const PrivateEmployeeSource = Object.freeze({
    ManagerHomeLocation : 0,
    Hyperfind: 1,
});
